import React, { useEffect, useState } from 'react';
import RibbonActions from '../components/RibbonActions';
import { getEmpleados, crearEmpleado, editarEmpleado, borrarEmpleado } from '../services/api';

const fmtCOP = n => '$' + Number(n || 0).toLocaleString('es-CO');

export default function Empleados() {
  const [lista, setLista]     = useState([]);
  const [verInactivos, setVerInactivos] = useState(false);
  const [modal, setModal]     = useState(null);  // null | { empleado? }
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(true);

  const cargar = async () => {
    setLoading(true);
    try {
      const params = verInactivos ? {} : { activo: true };
      const { data } = await getEmpleados(params);
      setLista(data); setError('');
    } catch (err) { setError(err.response?.data?.error || 'Error al cargar'); }
    finally { setLoading(false); }
  };
  useEffect(() => { cargar(); /* eslint-disable-line */ }, [verInactivos]);

  const onBorrar = async (id) => {
    if (!window.confirm('¿Marcar empleado como inactivo?')) return;
    try { await borrarEmpleado(id); cargar(); }
    catch (err) { alert(err.response?.data?.error); }
  };

  return (
    <div style={S.container}>
      <div style={S.headerRow}>
        <div>
          <h1 style={S.title}>Empleados</h1>
          <p style={S.sub}>Datos personales, contractuales y de seguridad social · {lista.length} empleados</p>
        </div>
        <RibbonActions><div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <label style={S.checkbox}>
            <input type="checkbox" checked={verInactivos} onChange={e => setVerInactivos(e.target.checked)} />
            Mostrar inactivos
          </label>
          <button onClick={() => setModal({})} style={S.btnPri}>+ Nuevo empleado</button>
        </div></RibbonActions>
      </div>

      {error && <div style={S.error}>{error}</div>}

      <table style={S.table}>
        <thead>
          <tr>
            <th style={S.th}>Documento</th>
            <th style={S.th}>Nombre</th>
            <th style={S.th}>Cargo</th>
            <th style={S.th}>Contrato</th>
            <th style={{ ...S.th, textAlign: 'right' }}>Salario</th>
            <th style={S.th}>EPS</th>
            <th style={S.th}>AFP</th>
            <th style={S.th}>ARL</th>
            <th style={S.th}>Estado</th>
            <th style={S.th}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {loading ? <tr><td colSpan={10} style={{ ...S.td, textAlign: 'center', padding: 30 }}>Cargando…</td></tr>
            : lista.length === 0 ? <tr><td colSpan={10} style={{ ...S.td, textAlign: 'center', padding: 30, color: '#94a3b8' }}>Sin empleados</td></tr>
            : lista.map(e => (
              <tr key={e.id} style={{ opacity: e.activo ? 1 : 0.55 }}>
                <td style={{ ...S.td, fontFamily: 'monospace' }}>{e.numero_documento}</td>
                <td style={S.td}>{e.apellidos}, {e.nombres}</td>
                <td style={S.td}>{e.cargo || '—'}</td>
                <td style={S.td}>{e.tipo_contrato}</td>
                <td style={{ ...S.td, textAlign: 'right', fontFamily: 'monospace' }}>{fmtCOP(e.salario_base)}</td>
                <td style={S.td}>{e.eps_nombre || '—'}</td>
                <td style={S.td}>{e.afp_nombre || '—'}</td>
                <td style={S.td}>Riesgo {e.arl_riesgo}</td>
                <td style={S.td}>
                  <span style={{ ...S.badge, background: e.activo ? '#dcfce7' : '#fee2e2', color: e.activo ? '#166534' : '#991b1b' }}>
                    {e.activo ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                <td style={S.tdAcc}>
                  <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                    <button style={S.iconBtn} title="Editar" onClick={() => setModal({ empleado: e })}>✏️</button>
                    {e.activo && <button style={{ ...S.iconBtn, borderColor: '#7f1d1d' }} title="Desactivar" onClick={() => onBorrar(e.id)}>🚫</button>}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {modal && <ModalEmpleado empleado={modal.empleado} onClose={() => setModal(null)} onSaved={() => { setModal(null); cargar(); }} />}
    </div>
  );
}

function ModalEmpleado({ empleado, onClose, onSaved }) {
  const editando = !!empleado;
  const [form, setForm] = useState(empleado || {
    tipo_documento: '13', numero_documento: '', nombres: '', apellidos: '',
    email: '', telefono: '', direccion: '', ciudad: '',
    fecha_ingreso: new Date().toISOString().slice(0, 10),
    cargo: '', tipo_contrato: 'indefinido',
    salario_base: '', recibe_aux_transporte: true,
    eps_nombre: '', afp_nombre: '', arl_riesgo: 'I', ccf_nombre: '',
    banco: '', cuenta_bancaria: '',
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const payload = { ...form, salario_base: Number(form.salario_base) };
      if (editando) await editarEmpleado(empleado.id, payload);
      else          await crearEmpleado(payload);
      onSaved();
    } catch (err) { setError(err.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };

  return (
    <div style={S.modalBg} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 16px', color: '#0f172a' }}>{editando ? `Editar ${empleado.nombres} ${empleado.apellidos}` : 'Nuevo empleado'}</h3>
        {error && <div style={S.error}>{error}</div>}
        <form onSubmit={submit}>
          <h4 style={S.section}>Identificación</h4>
          <div style={S.grid3}>
            <Field label="Tipo doc"><select value={form.tipo_documento} onChange={e => set('tipo_documento', e.target.value)} style={S.input}>
              <option value="13">CC</option><option value="22">CE</option><option value="11">RC</option><option value="31">NIT</option>
            </select></Field>
            <Field label="Número"><input value={form.numero_documento} onChange={e => set('numero_documento', e.target.value)} style={S.input} required /></Field>
            <Field label="Fecha ingreso"><input type="date" value={form.fecha_ingreso} onChange={e => set('fecha_ingreso', e.target.value)} style={S.input} required /></Field>
          </div>
          <div style={S.grid2}>
            <Field label="Nombres"><input value={form.nombres} onChange={e => set('nombres', e.target.value)} style={S.input} required /></Field>
            <Field label="Apellidos"><input value={form.apellidos} onChange={e => set('apellidos', e.target.value)} style={S.input} required /></Field>
          </div>

          <h4 style={S.section}>Contacto</h4>
          <div style={S.grid2}>
            <Field label="Email"><input type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} style={S.input} /></Field>
            <Field label="Teléfono"><input value={form.telefono || ''} onChange={e => set('telefono', e.target.value)} style={S.input} /></Field>
          </div>
          <div style={S.grid2}>
            <Field label="Dirección"><input value={form.direccion || ''} onChange={e => set('direccion', e.target.value)} style={S.input} /></Field>
            <Field label="Ciudad"><input value={form.ciudad || ''} onChange={e => set('ciudad', e.target.value)} style={S.input} /></Field>
          </div>

          <h4 style={S.section}>Contrato y salario</h4>
          <div style={S.grid3}>
            <Field label="Cargo"><input value={form.cargo || ''} onChange={e => set('cargo', e.target.value)} style={S.input} /></Field>
            <Field label="Tipo contrato"><select value={form.tipo_contrato} onChange={e => set('tipo_contrato', e.target.value)} style={S.input}>
              <option value="indefinido">Indefinido</option><option value="fijo">Fijo</option><option value="obra">Obra</option><option value="aprendizaje">Aprendizaje</option>
            </select></Field>
            <Field label="Salario base"><input type="number" min="0" step="1" value={form.salario_base} onChange={e => set('salario_base', e.target.value)} style={S.input} required /></Field>
          </div>
          <Field label=""><label style={S.checkbox}>
            <input type="checkbox" checked={!!form.recibe_aux_transporte} onChange={e => set('recibe_aux_transporte', e.target.checked)} />
            Recibe auxilio de transporte (aplica si salario ≤ 2 SMMLV)
          </label></Field>

          <h4 style={S.section}>Seguridad social</h4>
          <div style={S.grid3}>
            <Field label="EPS"><input value={form.eps_nombre || ''} onChange={e => set('eps_nombre', e.target.value)} style={S.input} /></Field>
            <Field label="AFP"><input value={form.afp_nombre || ''} onChange={e => set('afp_nombre', e.target.value)} style={S.input} /></Field>
            <Field label="Riesgo ARL"><select value={form.arl_riesgo} onChange={e => set('arl_riesgo', e.target.value)} style={S.input}>
              <option value="I">I (0.522%)</option><option value="II">II (1.044%)</option><option value="III">III (2.436%)</option><option value="IV">IV (4.350%)</option><option value="V">V (6.960%)</option>
            </select></Field>
          </div>
          <Field label="CCF"><input value={form.ccf_nombre || ''} onChange={e => set('ccf_nombre', e.target.value)} style={S.input} /></Field>

          <h4 style={S.section}>Cuenta bancaria</h4>
          <div style={S.grid2}>
            <Field label="Banco"><input value={form.banco || ''} onChange={e => set('banco', e.target.value)} style={S.input} /></Field>
            <Field label="Cuenta"><input value={form.cuenta_bancaria || ''} onChange={e => set('cuenta_bancaria', e.target.value)} style={S.input} /></Field>
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <button type="button" onClick={onClose} style={S.btnSec} disabled={saving}>Cancelar</button>
            <button type="submit" style={S.btnPri} disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 8 }}>
    {label && <label style={S.label}>{label}</label>}
    {children}
  </div>
);

const S = {
  container: { padding: 24, maxWidth: 1300, margin: '0 auto' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 14 },
  title:     { fontSize: 24, fontWeight: 700, color: '#0f172a', margin: 0 },
  sub:       { color: '#64748b', margin: '4px 0 0', fontSize: 13 },
  toolbar:   { display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 },
  checkbox:  { display: 'flex', alignItems: 'center', gap: 6, color: '#475569', fontSize: 13 },
  error:     { background: '#fee2e2', border: '1px solid #fca5a5', color: '#991b1b', padding: '8px 12px', borderRadius: 6, marginBottom: 12, fontSize: 13 },
  table:     { width: '100%', borderCollapse: 'collapse', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: 8, overflow: 'hidden' },
  th:        { background: '#f1f5f9', padding: '10px 12px', textAlign: 'left', fontSize: 12, color: '#475569', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.3, borderBottom: '1px solid #e2e8f0' },
  td:        { padding: '4px 12px', fontSize: 13, color: '#1e293b', borderBottom: '1px solid #f1f5f9' },
  tdAcc:     { padding: '6px 12px', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap' },
  badge:     { padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 500 },
  btnPri:    { padding: '8px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  btnSec:    { flex: 1, padding: '10px', background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1', borderRadius: 6, cursor: 'pointer', fontSize: 13 },
  btnEdit:   { padding: '4px 10px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, marginRight: 4 },
  btnDel:    { padding: '4px 10px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 },
  iconBtn:   { background: '#1e293b', border: '1px solid #334155', borderRadius: 6, width: 26, height: 26, cursor: 'pointer', fontSize: 13, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 },
  modalBg:   { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20, overflowY: 'auto' },
  modal:     { background: '#fff', borderRadius: 10, padding: 18, width: 720, maxWidth: '95vw', maxHeight: '95vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(0,0,0,0.3)' },
  section:   { margin: '14px 0 6px', fontSize: 12, color: '#3b82f6', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid #e2e8f0', paddingBottom: 4 },
  label:     { display: 'block', fontSize: 12, color: '#64748b', marginBottom: 3 },
  input:     { width: '100%', padding: '7px 10px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', background: '#fff' },
  grid2:     { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  grid3:     { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 },
};
